import ResetDialog from './ResetDialog';

export default ResetDialog;
